const React = require("react");
const Layout = require("../layout");
const Form = require("./form");

class NewInvoice extends React.Component {
  render() {
    const {
      invoice,
    } = this.props;

    return (
      <Layout>
        <h1>New invoice</h1>
        <Form {...invoice} />
      </Layout>
    );
  }
}

module.exports = NewInvoice;
